//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Select, Input, DoneRoundIcon, CloseBigIcon } from '@gamesb42/ui-kit';

import baseRequest from 'queries/baseRequest';
import { getCompanies } from 'api/company';
import CompanySelect from 'components/CompanySelect';
import useAlert from 'hooks/api/useAlert';

export default function EditModal({ onClose, getData, activeRecord }) {
  const [docType, setDocType] = useState(activeRecord?.title);

  const handleEdit = (result) => {
    baseRequest({
      path: `${process.env.REACT_APP_BASE_URL}/document_types/${activeRecord.id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify({ title: docType }),
      },
    })
      .then(() => getData())
      .finally(() => {
        onClose();
      });
  };

  return (
    <Modal
      open
      title="Edit document type"
      okButtonProps={{
        onMouseDown: () => handleEdit(),
      }}
      onCancel={onClose}
      okText="Save"
      cancelText="Cancel"
      width="838px"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        <div style={{ width: '100%' }}>
          <Input size="large" label="Document type" value={docType} onChange={(e) => setDocType(e.target.value)} />
        </div>
      </div>
    </Modal>
  );
}
